export const NUMBER_KEY = "trn_key";
export const RANGE_KEY = "pr_key";
export const SUBDEST_KEY = "sde_key";

export const ALLOCATED_NUMBERS_MODE = {
    account: "account",
    gan: "gan",
    transit: "transit"
};

export const resolveAllocatedNumbersMode = ({ isGanTrunks, isTransitTrunks }) => {
    if (isTransitTrunks) {
        return ALLOCATED_NUMBERS_MODE.transit;
    }

    if (isGanTrunks) {
        return ALLOCATED_NUMBERS_MODE.gan;
    }

    return ALLOCATED_NUMBERS_MODE.account;
};

export const isSupplierMode = (mode) => mode !== ALLOCATED_NUMBERS_MODE.account;

export const getInitialDisplayByMode = (mode) => {
    return mode === ALLOCATED_NUMBERS_MODE.gan ? "numbers" : "trunk_number";
};

export const getDownloadPlanType = (mode) => {
    if (mode === ALLOCATED_NUMBERS_MODE.gan) {
        return "gan";
    }

    if (mode === ALLOCATED_NUMBERS_MODE.transit) {
        return "transit";
    }

    return null;
};

export const getRowKeyByMode = ({ mode, currentDisplay }) => {
    if (mode === ALLOCATED_NUMBERS_MODE.transit) {
        return "key";
    }

    if (mode === ALLOCATED_NUMBERS_MODE.gan) {
        if (currentDisplay === "numbers") return "key";
        if (currentDisplay === "groups") return "id";
    }

    switch (currentDisplay) {
        case "trunk_number":
            return NUMBER_KEY;
        case "price_range":
            return RANGE_KEY;
        case "subdestination":
            return SUBDEST_KEY;
        default:
            return NUMBER_KEY;
    }
};
